export default {
  en: {
    PAGE_TITLE: 'Multi-Factor Authentication',
    SKIP_THIS_TIME: 'Skip this time',
    NOTE_MFA_NOW_REQUIRED: 'We\'ve upgraded our security requirements. Multi-factor authentication is required to continue.',
    NOTE_MFA_NOW_REQUIRED_DATE: 'We\'ve upgraded our security requirements. Multi-factor authentication will be required by {enforceDate}.',
    NOTE_AUTH_APP_REQUIRED: 'You must install an authenticator app before you begin. \u00a0{link}',
    NOTE_AUTH_APP_REQUIRED_LINK: 'Learn more about multi-factor authentication',
    SCAN_THIS_QRCODE_TITLE: '1. Open the authenticator app on your phone and scan this QR code.',
    SCAN_THIS_QRCODE_DESCRIPTION: {
      SCAN_INSTRUCTION: 'Scan the image below with the multi-factor authentication app on your phone.',
      NO_CAMERA_INSTRUCTION: 'Can\'t scan the QR code?',
      ENTER_CODE_APP: 'Enter this setup key into your authenticator app:',
    },
    ENTER_VALIDATION_DIGITS_TITLE: '2. Enter the 6-digit validation code from your app and click Enable.',
    ENTER_VALIDATION_DIGITS_DESCRIPTION: 'Click Enable to complete the setup.',
    VALIDATION_CODE: 'Validation code',
    VALIDATION_CODE_TOOLTIP: 'The 6-digit validation code displayed on your authenticator app',
    SECRET_HAS_BEEN_COPIED_TO_CLIPBOARD: 'The secret code has been copied to clipboard. Enter it on your authenticator app.',
    LOADING_QR_CODE: 'Loading the QR code',
    MFA_ENABLED_SUCCESS: 'Enabled multi-factor authentication successfully.',
  }
};